// $flagsImagePath: '~intl-tel-input/build/img/';
// $flagsImagePath: '/build/assets/'; // DEV
$flagsImagePath: 'https://smartsite-production.s3.amazonaws.com/smart-web-components/vendor/intl-tel-input/img/';
@import "~intl-tel-input/build/css/intlTelInput.css";
.iti__flag {background-image: url(#{$flagsImagePath}flags.png);}
@media (min-resolution: 2x) {
  .iti__flag {background-image: url(#{$flagsImagePath}flags@2x.png);}
}
.iti__selected-dial-code {
  font-family: $font-family-primary;
  color: $color-typography-typo-88;
  font-size: 12px;
}
.iti--show-selected-dial-code .iti__selected-flag {background-color: transparent !important;}
.iti--allow-dropdown input.iti__tel-input,
.iti--allow-dropdown input.iti__tel-input[type=text],
.iti--allow-dropdown input.iti__tel-input[type=tel],
.iti--show-selected-dial-code input.iti__tel-input,
.iti--show-selected-dial-code input.iti__tel-input[type=text],
.iti--show-selected-dial-code input.iti__tel-input[type=tel] {
  width: 100%;
}

:host {
  display: flex;
  flex-direction: column;

  slot {
    display: none;
  }
}

.disabled {
  color: $color-typography-typo-48;

  > smart-text {
    color: $color-typography-typo-48;
  }
}

.error {
  color: $color-action-destrutive;

  > smart-text {
    color: $color-action-destrutive;
  }
}

.container {
  display: flex;
  flex-direction: column;
  position: relative;
}

input, textarea {
  padding: $size-space-sm;
  margin: $size-space-xxs 0;
  border: 1px solid $color-base-gray-gray-3;
  border-radius: $size-radius-xxs;

  font-family: $font-family-primary;
  color: $color-typography-typo-88;

  &.error {
    outline: none;
    border-color: $color-action-destrutive;
  }

  &.search {
    padding-right: 42px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &:focus {
    outline: none;
    border-color: $color-base-brand-yellow;
  }

  &::placeholder {
    color: $color-typography-typo-48;
  }

  &[disabled] {
    color: $color-typography-typo-48;
    border-color: $color-base-gray-gray-2;
    background-color: $color-base-gray-gray-1;

    & + smart-icon {
      cursor: default;
    }
  }
}

textarea {
  resize: none;
  height: 128px;
}

smart-icon {
  position: absolute;
  right: $size-space-sm;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

span {
  font-family: $font-family-primary;
  font-size: $size-typography-caption;
  line-height: $size-line-height-caption;
  color: $color-typography-typo-48;

  &.error {
    color: $color-action-destrutive;
  }
}

/* clears the ‘X’ from Internet Explorer */
input[type=search]::-ms-clear { display: none; width : 0; height: 0; }
input[type=search]::-ms-reveal { display: none; width : 0; height: 0; }
/* clears the ‘X’ from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration { display: none; }
